import type { AnswerState } from './useSitting';

/**
 * The radio grid the real screen uses for "Which paragraph contains the
 * following information?" and "Match each statement with the correct
 * researcher".
 *
 * Statements are rows, the letters are columns, and one radio is marked per
 * row. A dropdown would be fewer pixels and the wrong test: the candidate is
 * rehearsing a screen they will meet in an exam hall, and the shape of the
 * control is part of what they are rehearsing.
 */

export interface GridRow {
  number: number;
  promptHtml: string | null;
  answer: AnswerState | undefined;
  onChange: (patch: Partial<AnswerState>) => void;
  onFocus: () => void;
}

export function MatchGrid({
  letters,
  rows,
  current,
  disabled,
}: {
  letters: string[];
  rows: GridRow[];
  current: number;
  disabled: boolean;
}) {
  return (
    <div className="qgrid__wrap">
      <table className="qgrid">
        <thead>
          <tr>
            <th className="qgrid__corner" scope="col">
              <span className="sr-only">Statement</span>
            </th>
            {letters.map((letter) => (
              <th key={letter} scope="col">
                {letter}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.number} data-current={row.number === current || undefined}>
              <td className="qgrid__stmt">
                <span className="xnum">{row.number}</span>
                {row.promptHtml ? (
                  <span data-markable dangerouslySetInnerHTML={{ __html: row.promptHtml }} />
                ) : (
                  <span className="muted">—</span>
                )}
              </td>
              {letters.map((letter) => (
                <td key={letter} className="qgrid__cell">
                  <label className="qgrid__radio">
                    <span className="sr-only">{`Question ${row.number}, answer ${letter}`}</span>
                    <input
                      type="radio"
                      name={`q${row.number}`}
                      disabled={disabled}
                      checked={(row.answer?.value ?? '').toUpperCase() === letter}
                      onFocus={row.onFocus}
                      onChange={() => row.onChange({ value: letter })}
                    />
                  </label>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
